import React, { useMemo, useState } from 'react';
import styled from '@emotion/styled';
import { Box } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';
import { themeGet } from 'styled-system';

import Text from '@/components/Text';
import PaginationItem from './components/PaginationItem';
import usePagination from './hooks';

const StyledList = styled.ul`
  display: flex;
  justify-content: center;
  list-style: none;
  margin: 0;
  padding: 0;
`;

const StyledListItem = styled.li`
  display: inline-block;
  font-weight: 700;
  text-align: center;

  & + & {
    margin-left: ${themeGet('space.4')};
  }
`;

const Pagination = ({
  itemsPerPage = 10,
  onPageChange = () => undefined,
  paginatedItem,
  totalItems,
}) => {
  const [numberOfPages, setNumberOfPages] = useState(0);

  useMemo(() => {
    setNumberOfPages(Math.ceil(totalItems / itemsPerPage));
  }, [itemsPerPage, totalItems]);

  const { items, firstItemNumber, lastItemNumber } = usePagination({
    itemsPerPage,
    numberOfPages,
    onPageChange,
    totalItems,
  });

  const paginationText = `${firstItemNumber} - ${lastItemNumber} of ${totalItems} ${paginatedItem}`;

  return (
    <Box textAlign="center">
      <StyledList>
        {items.map((item) => (
          <StyledListItem key={`${item.type}-${item.page}`}>
            <PaginationItem item={item} />
          </StyledListItem>
        ))}
      </StyledList>
      <Text display="block" mt={4}>
        {paginationText}
      </Text>
    </Box>
  );
};

Pagination.propTypes = {
  itemsPerPage: PropTypes.number,
  onPageChange: PropTypes.func,
  paginatedItem: PropTypes.string.isRequired,
  totalItems: PropTypes.number.isRequired,
};

export default Pagination;
